// OPEN ALL EXTERNAL LINKS IN NEW TAB
function targetBlank() {
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");
    var a = document.getElementsByTagName('a'); // grab every link on the page
    for (var i = 0; i < a.length; i++) {
        var href = a[i].host; // set the host of shopify link
        if( !internal.test(href) ) { // make sure the href of a element in loop doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attribute
        }
    }
};
// Run the function targetBlank()
targetBlank();


// Disable links on mega menu parents in the nav
document.querySelectorAll('.f-site-nav__item.f-site-nav__item--has-child a[href="#parent"]').forEach(link => {
  link.removeAttribute('href');
  link.style.cursor = 'pointer'; // preserve pointer cursor since href is gone
});


// ADD PRIVACY POLICY LINK & DISCLAIMER TEXT TO OUT-OF-STOCK APP
document.addEventListener('DOMContentLoaded', function () {
  addOutOfStockDisclaimer();
});

function addOutOfStockDisclaimer() {
  var container = document.querySelector('#esc-out-of-stock-inputs');

  // If the app injects this element asynchronously, watch for it
  if (!container) {
    var observer = new MutationObserver(function (mutations, obs) {
      var target = document.querySelector('#esc-out-of-stock-inputs');
      if (target) {
        insertDisclaimer(target);
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return;
  }

  insertDisclaimer(container);
}

function insertDisclaimer(container) {
  // Avoid adding it twice
  if (container.querySelector('.esc-privacy-disclaimer')) return;

  var disclaimer = document.createElement('div');
  disclaimer.className = 'esc-privacy-disclaimer';

  disclaimer.innerHTML =
    'By subscribing you agree to the ' +
    '<a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>' +
    ' and provide consent to receive updates.';

  container.appendChild(disclaimer);
}